import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import './index.scss';
import './fonts.scss';
import CanadaTable from './canada/CanadaTable';
import UsTable from './us/UsTable';
import * as serviceWorker from './us/serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Route path={`${process.env.PUBLIC_URL}/hr-table-us`} component={UsTable} />
      <Route path={`${process.env.PUBLIC_URL}/hr-table-canada`} component={CanadaTable} />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
